<i18n
  src="@/locales/views/agro_exporter/liquidations/query_by_provider/show_process.yml"
  lang="yaml"
></i18n>

<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      :name="routeName('list_processes')"
      :params="{
        agro_exporter_id: this.agro_exporter_id
      }"
    ></go-back-link>

    <template v-if="load_general_data">
      <bread-crumbs :labels="[module_name, agro_exporter_process.name]" />

      <div class="mt-6 px-4">
        <tabs-container v-model="option_tabs" :with_routing="true" />
      </div>

      <router-view
        v-if="show_content_tab"
        :providers="providers"
        :liquidations_monthly="liquidations_monthly"
        :total_advances="total_advances"
        :totals_monthly="totals_monthly"
        :crop_sizes="crop_sizes"
        :totals_weekly="totals_weekly"
        :totals_providers_weekly="totals_providers_weekly"
        :crop_size_weekly="crop_size_weekly"
        :crop_size_earning_weekly="crop_size_earning_weekly"
        :crop_size_labels="crop_size_labels"
      ></router-view>
    </template>
    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/liquidations/query_by_provider/show_process.js";

export default {
  name: "AELiquidationsQueryByProviderShowProcess",
  props: ["agro_exporter_process_id", "agro_exporter_id"],
  data() {
    return {
      load_general_data: false,
      load_data_summary: false,
      load_data_weekly: false,
      load_data_providers: false,
      option_tabs: [],
      agro_exporter_process: {},
      providers: [],
      liquidations: [],
      liquidations_monthly: {},
      totals_monthly: {},
      totals_weekly: {},
      totals_providers_weekly: {},
      crop_size_weekly: {},
      crop_size_labels: [],
      total_advances: 0,
      crop_sizes: {},
      crop_size_earning_weekly: {},
    };
  },
  computed: {
    show_content_tab: function () {
      const route_name = this.$route.name;
      if (
        (route_name == this.routeName("show_process_summary") &&
          this.load_data_summary) ||
        (route_name == this.routeName("show_process_weekly") &&
          this.load_data_weekly) ||
        (route_name == this.routeName("show_process_providers") &&
          this.load_data_providers)
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    fetchData: async function () {
      await this.fetchAgroExporterProcess();
      await this.loadDataByTab();
      this.load_general_data = true;
    },
    loadDataByTab: async function () {
      if (this.option_tabs[0].current && !this.load_data_summary) {
        await this.fetchLiquidationMonthly();
        await this.fetchTotalAdvances();
        await this.fetchTotalsMonthly();
        await this.fetchCropSizes();
        this.load_data_summary = true;
      }
      if (this.option_tabs[1].current && !this.load_data_weekly) {
        await this.fetchTotalsWeekly();
        await this.fetchProviders();
        await this.fetchTotalsProvidersWeekly();
        await this.fetchCropSizeLabels();
        await this.fetchCropSizeWeekly();
        await this.fetchCropSizeEarningWeekly();
        this.load_data_weekly = true;
      }
      if (this.option_tabs[2].current && !this.load_data_providers) {
        await this.fetchProviders();
      }
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchProviders: async function () {
      let response = await Requester.fetchProviders(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.providers = response.data;
      this.load_data_providers = true;
    },
    fetchLiquidationMonthly: async function () {
      let response = await Requester.fetchLiquidationMonthly(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.liquidations_monthly = response.data;
    },
    fetchTotalAdvances: async function () {
      let response = await Requester.fetchTotalAdvances(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.total_advances = response.data;
    },
    fetchTotalsMonthly: async function () {
      let response = await Requester.fetchTotalsMonthly(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.totals_monthly = response.data;
    },
    fetchCropSizes: async function () {
      let response = await Requester.fetchCropSizes(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.crop_sizes = response.data;
    },
    fetchTotalsWeekly: async function () {
      let response = await Requester.fetchTotalsWeekly(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.totals_weekly = response.data;
    },
    fetchTotalsProvidersWeekly: async function () {
      let response = await Requester.fetchTotalsProvidersWeekly(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.totals_providers_weekly = response.data;
    },
    fetchCropSizeLabels: async function () {
      let response = await Requester.fetchCropSizeLabels(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.crop_size_labels = response.data;
    },
    fetchCropSizeWeekly: async function () {
      let response = await Requester.fetchCropSizeWeekly(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.crop_size_weekly = response.data;
    },
    fetchCropSizeEarningWeekly: async function () {
      let response = await Requester.fetchCropSizeEarningWeekly(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id
      );
      this.crop_size_earning_weekly = response.data;
    },
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.tabs.summary"),
          icon: "fa-solid fa-chart-pie",
          route: { name: this.routeName("show_process_summary") },
          current: this.$route.name == this.routeName("show_process_summary")
        },
        {
          name: this.$t("labels.tabs.weekly"),
          icon: "fa-solid fa-chart-pie",
          route: { name: this.routeName("show_process_weekly") },
          current: this.$route.name == this.routeName("show_process_weekly")
        },
        {
          name: this.$t("labels.tabs.providers"),
          icon: "fa-solid fa-users",
          route: { name: this.routeName("show_process_providers") },
          current: this.$route.name == this.routeName("show_process_providers")
        }
      ];
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fillOptions();
        this.fetchData();
      })
    );
  },
  watch: {
    option_tabs() {
      this.loadDataByTab();
    }
  }
};
</script>
